import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';

interface OnboardingSlideProps {
  onComplete: () => void;
  isCompleting: boolean;
  isLastSlide: boolean;
  onNext?: () => void;
  onGenderSelect?: (gender: string) => void;
}

export const OnboardingSlide5 = ({ onComplete, isCompleting }: OnboardingSlideProps) => {
  const navigate = useNavigate();

  return (
    <Card className="shadow-card border-0 bg-gradient-card">
      <CardContent className="p-6 md:p-8 flex flex-col items-center justify-center text-center">
      {/* Hero Visual - Animated completion checkmark */}
      <div className="mb-6 flex justify-center">
        <div className="w-24 h-24 md:w-28 md:h-28 rounded-full bg-primary flex items-center justify-center animate-scale-in shadow-glow">
          <CheckCircle 
            className="w-12 h-12 md:w-14 md:h-14 text-white" 
            style={{
              animation: 'bounce 1s ease-in-out 3'
            }}
          />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-xl md:text-2xl font-semibold mb-3 animate-fade-in">
        Let's Begin Your FaceFable Journey
      </h2>

      {/* Subtext */}
      <p className="text-sm text-muted-foreground max-w-2xl mb-6 animate-fade-in" style={{ animationDelay: '0.2s' }}>
        Discover what your skin really needs. Take your first FaceScan or SkinSync™ to start your personalised plan.
      </p>

      {/* CTAs */}
      <div className="flex flex-col gap-3 w-full max-w-md animate-fade-in" style={{ animationDelay: '0.4s' }}>
        <Button
          size="lg"
          className="w-full bg-gradient-primary hover:opacity-90 shadow-button"
          onClick={onComplete}
          disabled={isCompleting}
        >
          {isCompleting ? 'Loading...' : 'Get Started'}
        </Button>
      </div>
      </CardContent>
    </Card>
  );
};
